import { MessageSquare, Phone, Mail } from 'lucide-react';

const ICON_MAP = { MessageSquare, Phone, Mail };

const DEFAULTS = [
  { id: 'live_chat', icon: 'MessageSquare', title: 'Live Chat', subtitle: 'Chat with us now', bgColor: '#007a33', bgColorDark: '#007a33' },
  { id: 'whatsapp', icon: 'Phone', title: 'WhatsApp', subtitle: 'Message us on WhatsApp', bgColor: '#25D366', bgColorDark: '#25D366' },
  { id: 'email', icon: 'Mail', title: 'Email', subtitle: 'Send us an email', bgColor: '#1a472a', bgColorDark: '#1a472a' },
];

export function ContactSection({ content, theme, t }) {
  const blocks = content.contact?.blocks || DEFAULTS;
  const badge = content.contact?.badge;
  const title = content.contact?.title;
  const subtitle = content.contact?.subtitle;
  const titleColor = content.contact?.titleColor;
  const subtitleColor = content.contact?.subtitleColor;
  const isDark = theme === 'dark';

  return (
    <section key="contact" id="contact" data-section="contact" className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        {(badge || title || subtitle) && (
          <div className="text-center mb-12">
            {badge && (
              <span className="inline-block bg-[#007a33] text-white border-[#007a33] mb-4 px-4 py-1 text-[0.7rem] font-black tracking-[1px] rounded-full">
                {badge}
              </span>
            )}
            {title && (
              <h2 className="text-3xl sm:text-4xl font-bold mb-4" style={titleColor ? { color: titleColor } : undefined}>
                {title}
              </h2>
            )}
            {subtitle && (
              <p className={`text-lg ${!subtitleColor ? t.textSecondary : ''}`} style={subtitleColor ? { color: subtitleColor } : undefined}>
                {subtitle}
              </p>
            )}
          </div>
        )}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {blocks.map((block, i) => {
            const Icon = ICON_MAP[block.icon] || MessageSquare;
            const bg = isDark ? (block.bgColorDark || block.bgColor || '#007a33') : (block.bgColor || '#007a33');
            const textDark = !isDark && i > 0;
            const textClass = textDark ? 'text-gray-900' : 'text-white';
            const subtextClass = textDark ? 'text-gray-600' : 'text-white/80';
            const isLiveChat = i === 0 || block.id === 'live_chat';
            const isWhatsApp = block.id === 'whatsapp';
            const isEmail = block.id === 'email';
            const handleClick = isLiveChat
              ? () => window.dispatchEvent(new Event('open-live-chat'))
              : isWhatsApp && block.linkValue
                ? () => window.open(`https://wa.me/${block.linkValue}`, '_blank')
                : isEmail && block.linkValue
                  ? () => window.location.href = `mailto:${block.linkValue}`
                  : undefined;
            return (
              <div
                key={block.id || i}
                className={`rounded-3xl p-8 text-center flex flex-col items-center gap-3 transition-transform hover:scale-[1.02] ${i === 0 ? 'md:col-span-2' : ''} ${textClass} ${handleClick ? 'cursor-pointer' : ''}`}
                style={{ backgroundColor: bg }}
                onClick={handleClick}
                data-testid={`contact-block-${block.id || i}`}
              >
                <div className={`w-14 h-14 rounded-full ${textDark ? 'bg-black/10' : 'bg-white/10'} flex items-center justify-center`}>
                  <Icon className="w-7 h-7" />
                </div>
                <h3 className="text-xl font-bold">{block.title}</h3>
                <p className={`${subtextClass} text-sm`}>{block.subtitle}</p>
                {block.description && (
                  <p className={`${subtextClass} text-sm max-w-md`}>{block.description}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
